export const CREATE_WORK_STATUS_MUTATION = `
  mutation CreateWorkStatus($object: work_status_insert_input!) {
    insert_work_status_one(object: $object) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const UPDATE_WORK_STATUS_MUTATION = `
  mutation UpdateWorkStatus($id: Int!, $set: work_status_set_input!) {
    update_work_status_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      name
      description
      status
      company_id
      company {
        id
        name
      }
      created_at
      updated_at
    }
  }
`;

export const DELETE_WORK_STATUS_MUTATION = `
  mutation DeleteWorkStatus($id: Int!) {
    delete_work_status_by_pk(id: $id) {
      id
    }
  }
`; 